import PropTypes from 'prop-types';
import ArticleActions from '../../articleActions/articleActions';
import SavePdfAnchor from '../../articleActions/actionTypes/savePdfAnchor';
import ViewPdfAnchor from '../../articleActions/actionTypes/viewPdfAnchor';
import { PiiArticleEventsPropTypes } from '../../../utils/trackers/createArticleEvents';

export default function PiiReferencePreviewActions(
  {
    pii,
    pdfPath,
    savePdfEventData,
    viewPdfEventData,
  },
) {
  return (
    <ArticleActions>
      <ViewPdfAnchor
        id={`pii-reference-preview-${pii}`}
        pii={pii}
        viewPdfEventData={viewPdfEventData}
      />
      {pdfPath && <SavePdfAnchor pdfPath={pdfPath} savePdfEventData={savePdfEventData} />}
    </ArticleActions>
  );
}

PiiReferencePreviewActions.propTypes = {
  pii: PropTypes.string.isRequired,
  pdfPath: PropTypes.string,
  savePdfEventData: PiiArticleEventsPropTypes.savePdf,
  viewPdfEventData: PiiArticleEventsPropTypes.viewPdf,
};

PiiReferencePreviewActions.defaultProps = {
  pdfPath: undefined,
  savePdfEventData: undefined,
  viewPdfEventData: undefined,
};
